import {isBrowser} from '@helios/shared/utils/browser'

/**
 *
 * @param key The key of the session storage to hook with
 * @param initialValue optional initial value to assign to the hooked session storage
 * @param raw wether or not we want to process the raw data
 * This hook abstract the sessionStorage API to access from and set data to sessionStorage
 */

export const useSessionStorage = <T extends any>(
    key: string,
    initialValue?: T,
    raw?: boolean
): [T, (value: T) => void] => {
    if (!isBrowser) {
        return [initialValue as T, () => {}]
    }

    const json = sessionStorage.getItem(key)
    const item = json ? (raw ? String(initialValue) : JSON.parse(json)) : json
    const setItem = (value: T) =>
        sessionStorage.setItem(key, raw ? String(initialValue) : JSON.stringify(value))
    return [item, setItem]
}

export default useSessionStorage
